import StringValueObject from "../../../shared/domain/value-object/string-value-object";

export default class AnimeTitleJapanese extends StringValueObject {

}